import React from 'react';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import styled from 'styled-components';
const HopeVisitWrapper = styled.div.withConfig({
  displayName: "HopeVisitContent__HopeVisitWrapper",
  componentId: "blnd17-0"
})(["display:flex;flex-direction:column;align-items:center;"]);
const ControlWrapper = styled.div.withConfig({
  displayName: "HopeVisitContent__ControlWrapper",
  componentId: "blnd17-1"
})(["margin:5px;"]);

var _ref = /*#__PURE__*/React.createElement(FormControlLabel, {
  value: "YES",
  control: /*#__PURE__*/React.createElement(Radio, {
    size: "small"
  }),
  label: "Yes",
  labelPlacement: "top"
});

var _ref2 = /*#__PURE__*/React.createElement(FormControlLabel, {
  value: "NO",
  control: /*#__PURE__*/React.createElement(Radio, {
    size: "small"
  }),
  label: "No",
  labelPlacement: "top"
});

var _ref3 = /*#__PURE__*/React.createElement(MenuItem, {
  value: "Patient Died"
}, "Patient died");

var _ref4 = /*#__PURE__*/React.createElement(MenuItem, {
  value: "Patient Discharged"
}, "Patient Discharged");

var _ref5 = /*#__PURE__*/React.createElement(MenuItem, {
  value: "Patient Refused"
}, "Patient Refused");

var _ref6 = /*#__PURE__*/React.createElement(MenuItem, {
  value: "Provider Unavailable"
}, "Provider Unavailable");

export const HopeVisitContent = ({
  HopeVisitHappened,
  handleChange,
  value
}) => {
  const message = HopeVisitHappened ? `Have the patient's pain symptoms improved since the last visit?` : `Select reason no HopeVisit was completed.`;
  return /*#__PURE__*/React.createElement(HopeVisitWrapper, null, /*#__PURE__*/React.createElement("div", null, message), /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset"
  }, /*#__PURE__*/React.createElement(ControlWrapper, null, HopeVisitHappened ? /*#__PURE__*/React.createElement(RadioGroup, {
    value: value,
    onChange: event => handleChange(event.target.value),
    row: true
  }, _ref, _ref2) : /*#__PURE__*/React.createElement(Select, {
    value: value || '',
    onChange: event => handleChange(event.target.value)
  }, _ref3, _ref4, _ref5, _ref6))));
};